import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CacheRestoreService } from '../cache-restore-service';

/**
 * 基于 SessionStorage 的缓存恢复服务实现
 *
 * 从 sessionStorage 中恢复数据，恢复后立即清除缓存
 */
@injectable()
export class SessionStorageCacheRestoreService implements CacheRestoreService {
    restore(cacheKey: string): string {
        const cached = sessionStorage.getItem(cacheKey);
        if (cached !== null) {
            sessionStorage.removeItem(cacheKey);
            return cached;
        }
        return '';
    }

    restoreMultiple(cacheKeys: string[]): string[] {
        return cacheKeys.map(key => this.restore(key));
    }
}
